import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  login,
  register,
  logout,
  changePassword,
  resetPassword,
} from "libs/api/auth";
import { sendVerifyCode } from "libs/api/verify"; // note: be able to use send verify registerp and forget password
// import { getCompany } from "libs/api/company";
import { updateProfile } from "libs/api/user";

// *** Login Thunk ***
export const loginThunk = createAsyncThunk(
  "login",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, pathname, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await login(pathname, body);
      typeof cbFulfilled === "function" && cbFulfilled(response);
      return response.data; // note: only return user data to store in localstorage
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        // Throw error dengan message yang lebih deskriptif
        const errorMessage =
          error.response.data?.message || "Login gagal. Silakan coba lagi.";
        throw new Error(errorMessage);
      }
      typeof cbRejected === "function" && cbRejected(error);
      const errorMessage =
        error.message || "Terjadi kesalahan. Silakan coba lagi.";
      throw new Error(errorMessage);
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

// *** Register Thunk ***
export const registerThunk = createAsyncThunk(
  "register",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, pathname, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await register(pathname, body);
      typeof cbFulfilled === "function" && cbFulfilled(response);
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw error.response.data;
      }
      typeof cbRejected === "function" && cbRejected(error);
      throw error;
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

// *** Logout Thunk ***
export const logoutThunk = createAsyncThunk(
  "logout",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    queryParams,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await logout(pathname, queryParams);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw error.response.data;
      }
      typeof cbRejected === "function" && cbRejected(error);
      throw error;
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

// *** Forget Password Thunk ***
export const forgetPasswordThunk = createAsyncThunk(
  "forget-password",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    queryParams,
    body,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await sendVerifyCode(pathname, queryParams, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

// *** Change Password Thunk ***
export const changePasswordThunk = createAsyncThunk(
  "change-password",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, pathname, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await changePassword(pathname, body);
      typeof cbFulfilled === "function" && cbFulfilled(response);
      return response.data; // note: only return user data to store in localstorage
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw error.response.data;
      }
      typeof cbRejected === "function" && cbRejected(error);
      throw error;
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

// *** Reset Password Thunk ***
export const resetPasswordThunk = createAsyncThunk(
  "reset-password",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    queryParams,
    body,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await resetPassword(pathname, queryParams, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

// *** Get company by user has registered ***
// export const getCompanyByUserHasRegisteredThunk = createAsyncThunk(
//   "company-by-user-registered",
//   async ({
//     cbPending,
//     cbFulfilled,
//     cbRejected,
//     cbFinally,
//     pathname,
//     queryParams,
//     accessToken,
//   }) => {
//     try {
//       typeof cbPending === "function" && cbPending();
//       const response = await getCompany(pathname, queryParams, accessToken);

//       typeof cbFulfilled === "function" && cbFulfilled();
//       return response?.data;
//     } catch (error) {
//       if (error.response) {
//         typeof cbRejected === "function" && cbRejected(error.response);
//         throw error.response.data;
//       }
//       typeof cbRejected === "function" && cbRejected(error);
//       throw error;
//     } finally {
//       typeof cbFinally === "function" && cbFinally();
//     }
//   }
// );

// *** Fill biodata ***
export const fillBiodataThunk = createAsyncThunk(
  "fill-biodata",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    body,
    accessToken,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await updateProfile(pathname, body, accessToken);

      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw error.response.data;
      }
      typeof cbRejected === "function" && cbRejected(error);
      throw error;
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);
